import {
  FIELD_TYPES,
  FIELD_PARAMS,
  CLEAR_SPECIALTIES_TAG,
  CLEAR_SPECIALTIES
} from "../../utils/constants";

const updateSelected = ({ options = [] }, { data, value }) => {
  if (Array.isArray(options)) {
    options.forEach(option => {
      if (option?.name === data?.fieldOptionName) {
        option.selected = value;
      }
    });
  }
};

const updateAction = (componentToUpdate, { data: { action } }) => {
  componentToUpdate.action = action;
  if (action === null) {
    componentToUpdate.updatedAction = true;
  }
};

const updateLayout = (componentToUpdate, { data }) => {
  componentToUpdate.updatedLayout = { ...data };
};

const resetLayout = componentToUpdate => {
  const { updatedLayout, updatedTextColor } = componentToUpdate;

  if (updatedLayout) {
    componentToUpdate.updatedLayout = null;
  }
  if (updatedTextColor) {
    componentToUpdate.updatedTextColor = null;
  }
};

const findStatesToApply = (eventStates = [], field) =>
  eventStates.filter(eventState =>
    eventState.tags
      .split("|")
      .find(tag =>
        field?.data?.actionEventStatesTags
          ? field?.data?.actionEventStatesTags.split("|").includes(tag)
          : null
      )
  );

const setErrorState = (componentToUpdate, { value }) => {
  componentToUpdate.isErrorStatus = value === "true";
  componentToUpdate.isValid = !componentToUpdate.isErrorStatus;
};

const updateActionEventStates = (
  componentToUpdate,
  { data: { actionEventStates } }
) => {
  componentToUpdate.data.updatedActionEventStates = actionEventStates;
};

const resetActionEventStates = componentToUpdate => {
  componentToUpdate.data.updatedActionEventStates = null;
};

const updateTextColor = (componentToUpdate, { value }) => {
  componentToUpdate.updatedTextColor = { color: value };
};

const updatedVisibility = (componentToUpdate, { value }) => {
  if (value === "gone") {
    componentToUpdate.layout.visible = false;
    if (componentToUpdate.params) {
      if (!componentToUpdate.params.includes(FIELD_PARAMS.fieldOptionHidden)) {
        componentToUpdate.params += `|${FIELD_PARAMS.fieldOptionHidden}`;
      }
    }
  }
  if (value === "visible") {
    if (componentToUpdate.layout) {
      componentToUpdate.layout.visible = true;
    }
    if (componentToUpdate.params) {
      componentToUpdate.params = componentToUpdate.params.replace(
        FIELD_PARAMS.fieldOptionHidden,
        ""
      );
    }
  }
};

const applyPropertyToField = (properties, field, appData) => {
  properties.forEach(property => {
    const eventType = property?.type;
    if (typeof updateEventsMap[eventType] === "function") {
      updateEventsMap[eventType](field, property, appData);
    }
  });
};

export const clearInput = (componentToUpdate, _, appData) => {
  const options = componentToUpdate?.options;
  if (
    componentToUpdate.type === FIELD_TYPES.formCheckboxContainer ||
    componentToUpdate.type === FIELD_TYPES.expandoField ||
    componentToUpdate.type === FIELD_TYPES.formTextField
  ) {
    appData.handleChange({ [componentToUpdate.name]: "" });
    if (options) {
      options.forEach(option => {
        option.selected = false;
      });
    }
    if (
      componentToUpdate.data?.actionEventStatesTags
        .split("|")
        .includes(CLEAR_SPECIALTIES_TAG)
    ) {
      appData.handleChange({ [CLEAR_SPECIALTIES]: true });
      componentToUpdate.text = "";
    }
  } else if (
    componentToUpdate.type === FIELD_TYPES.cellWithSwitch ||
    componentToUpdate.type === FIELD_TYPES.modernizedToggle
  ) {
    const yesOption = options.find(option => option.name === "Y");
    yesOption.selected = false;
    appData.handleChange({ [componentToUpdate.name]: "N" });
  } else {
    appData.handleChange({ [componentToUpdate.name]: "" });
  }
};

const updateText = (componentToUpdate, { value }) => {
  if (value) {
    componentToUpdate.title = value;
  }
};

const updateEventsMap = {
  updateAction,
  updateLayout,
  resetLayout,
  clearInput,
  updateActionEventStates,
  resetActionEventStates,
  isSelected: updateSelected,
  isErrorStatus: setErrorState,
  textColor: updateTextColor,
  visibility: updatedVisibility,
  text: updateText
};

export const updateFieldStates = (eventStates = [], fields = [], appData) => {
  fields.forEach(field => {
    const eventStatesToApply = findStatesToApply(eventStates, field);

    if (eventStatesToApply?.length) {
      eventStatesToApply.forEach(({ properties, data }) => {
        if (properties) {
          if (data?.skip_if_not_error_status) {
            if (
              field.isErrorStatus === undefined ||
              !field.isErrorStatus === false
            ) {
              applyPropertyToField(properties, field, appData);
            }
          } else {
            applyPropertyToField(properties, field, appData);
          }
        }
      });
    }

    if (field?.type === "container") {
      updateFieldStates(
        eventStates,
        field?.fieldLayouts?.[0]?.containerFields,
        appData
      );
    }
  });
};

export const getFieldActionEventStates = (field, eventType) => {
  const actionEventStates =
    field?.data?.updatedActionEventStates || field?.data?.actionEventStates;

  return Array.isArray(actionEventStates)
    ? actionEventStates.find(({ event }) => event?.type === eventType)?.states
    : null;
};

export const actionEventsMap = {
  onMarkerSelectEvent: "onMarkerSelect",
  onItemSelectEvent: "onItemSelect",
  onClick: "onClick"
};
